import React from 'react'
import { useSelector } from 'react-redux'

import { useCart } from '~shared-components/hooks/useCart'
import { useCartModal } from '~shared-components/hooks/useCartModal'
import { LoginSelector } from '~shared-components/redux/selectors/login.selector'

import { RequestQuoteModal } from './RequestQuoteModal'
import { UpdateOrderLineModal } from './UpdateOrderLineModal'

export const CartModalsController = () => {
  const customerContext = useSelector(LoginSelector.selectedCustomerContext)
  const locations = useSelector(LoginSelector.shipToLocations)
  const shipToLocationId = useSelector(LoginSelector.selectedLocationId)

  const { orderProduct } = useCart()
  const {
    closeAddProductToCart,
    closeRequestQuoteForProduct,
    isOpen,
    product,
    type,
  } = useCartModal()

  if (customerContext == undefined) return null

  return (
    <>
      <UpdateOrderLineModal
        isOpen={type == 'cart' && isOpen}
        mode="add"
        onClose={closeAddProductToCart}
        onUpdateProductQuantity={orderProduct}
        product={product}
        shipToLocationId={shipToLocationId}
      />

      <RequestQuoteModal
        customerNumber={customerContext.customerNumber}
        isOpen={type === 'quote' && isOpen}
        locations={locations}
        onClose={closeRequestQuoteForProduct}
        product={product}
        shipToLocationId={shipToLocationId}
      />
    </>
  )
}
